<div class="flex flex-col gap-1">
  <!-- Section Above The Table -->

  <div class="flex flex-row gap-1">
    <ag-toolbar
      class="flex-grow"
      showCreate="true"
      showDelete="true"
      showRename="true"
      showSave="true"
      showDuplicate="true"
      showFieldToggle="true"
      [configType]="configType()"
      [rows]="rows()"
      [cols]="cols()"
      [values]="values()"
      [data]="data()"
      [canSaveAsPublic]="canSaveAsPublic()"
      (selectedReportChange)="handleReportChange($event)"
      (exportClicked)="exportExcel($event)"
    />

    @if (showFieldToggle()) {
      <ag1-button variant="secondary" (clickEvent)="handleConfigClick()">
        <!-- project icon here -->
        <svg
          fill="currentColor"
          viewBox="0 0 512 512"
          xmlns="http://www.w3.org/2000/svg"
          class="w-5"
        >
          <g>
            <g>
              <g>
                <path
                  d="M0,0v512h224v-32h-32V192h256v-32h-96V32h128v64h32V0H0z M160,480H32V352h128V480z M160,320H32V192h128V320z M160,160H32
                    V32h128V160z M320,160H192V32h128V160z"
                />
                <path
                  d="M468.8,288.848l6.032-30.4l-69.568-40.16l-23.36,20.432h-27.856l-23.36-20.432l-69.536,40.16l6,30.4L253.2,313.024
                    L224,322.96v80.32l29.2,9.936l13.952,24.176l-6.032,30.4l69.568,40.16l23.36-20.432h27.904l23.36,20.432l69.536-40.16l-6-30.4
                    l13.952-24.16l29.2-9.952v-80.32l-29.2-9.952L468.8,288.848z M480,380.368l-18.896,6.4l-25.904,45.04l3.904,19.76L409.152,468.8
                    l-15.168-13.264h-51.968L326.848,468.8l-29.872-17.248l3.904-19.76L274.912,386.8L256,380.368v-34.496l18.912-6.4L300.88,294.4
                    l-3.904-19.76l29.872-17.248l15.168,13.264h51.968l15.168-13.28l29.872,17.264L435.2,294.4l25.984,45.024l18.896,6.4L480,380.368
                    z"
                />
                <rect x="480" y="192" width="32" height="32" />
                <rect x="480" y="128" width="32" height="32" />
                <path
                  d="M368,299.2c-35.346,0-64,28.654-64,64c0,35.346,28.654,64,64,64c35.346,0,64-28.654,64-64
                    C432,327.854,403.346,299.2,368,299.2z M368,395.2c-17.673,0-32-14.327-32-32c0-17.673,14.327-32,32-32c17.673,0,32,14.327,32,32
                    C400,380.873,385.673,395.2,368,395.2z"
                />
              </g>
            </g>
          </g>
        </svg>
      </ag1-button>
    }
  </div>

  @if (isLoading()) {
    <ng-container *ngTemplateOutlet="loading" />
  }

  <!-- Section Inline With The Table -->
  @if (!isLoading()) {
    <div class="flex gap-1">
      <!-- Actual Pivot Table -->
      @if (renderer() === "table") {
        <div class="flex-grow overflow-x-auto rounded" #pivot></div>
      }
      <!-- style.width below is a bit of a hack to get the graph to recalculate it's width when toggling the fields -->
      @if (renderer() !== "table") {
        <ag-pivot-chart
          class="h-[500px] flex-grow"
          [style.width]="showFields ? '1px' : ''"
          [rawDataHash]="chartData"
          [rows]="rows()"
          [cols]="cols()"
          [chartType]="renderer()"
        />
      }
      @if (showFields) {
        <div class="min-w-[30vw]">
          <ag-field-drawer
            [possibleFields]="possibleFields()"
            [(rows)]="rows"
            [(cols)]="cols"
            [(values)]="values"
            (configChange)="handleFieldConfigChange()"
          />
        </div>
      }
    </div>
  }
</div>

<ng-template #loading>
  <div class="grid w-full place-items-center gap-2 p-5">
    <ag1-loader />
  </div>
</ng-template>
